var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapeEllipse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "580px",
    height: "580px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "nonzero",
    clipRule: "nonzero",
    viewBox: "0 0 5800 5800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shape_ellipse icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "shape_ellipse icon from the IconExperience.com I-Collection. Copyright by INCORS GmbH (www.incors.com).")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "curve28",
    fill: "#000000",
    d: "M2900 1200c-669,0 -1274,194 -1710,508 -426,307 -690,729 -690,1192 0,463 264,885 690,1192 436,314 1041,508 1710,508 669,0 1274,-194 1710,-508 426,-307 690,-729 690,-1192 0,-463 -264,-885 -690,-1192 -436,-314 -1041,-508 -1710,-508zm-1826 346c469,-337 1115,-546 1826,-546 711,0 1357,209 1826,546 478,345 774,823 774,1354 0,531 -296,1009 -774,1354 -469,337 -1115,546 -1826,546 -711,0 -1357,-209 -1826,-546 -478,-345 -774,-823 -774,-1354 0,-531 296,-1009 774,-1354z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeEllipse);
export default __webpack_public_path__ + "static/media/shape_ellipse.0d269936d222eb7ef42d108dde2cd126.svg";
export { ForwardRef as ReactComponent };